// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1oQJF","inputWrap":"Table_inputWrap__2DcgF","col":"Table_col__2vb9n","bmiTooltip":"Table_bmiTooltip__2w-26"};